export default __webpack_public_path__ + "static/media/aut2.cc019b70.jpeg";